export enum MaintenanceForwardingSectionStyle {
  Default = 'default',
  Pending = 'pending',
  Waiting = 'waiting',
  Completed = 'completed',
}

export const maintenanceForwardingSectionStyles: Record<MaintenanceForwardingSectionStyle, string> = {
  [MaintenanceForwardingSectionStyle.Default]: 'bg-white-100 border border-gray-soft',
  [MaintenanceForwardingSectionStyle.Pending]: 'bg-yellow-op-2 border border-warning-secondary',
  [MaintenanceForwardingSectionStyle.Waiting]: 'bg-blue-200 border border-brand-100',
  [MaintenanceForwardingSectionStyle.Completed]: 'bg-success-op border border-success-tertiary',
}
